import { html } from '../core/html.js';
import { t } from '../core/i18n.js';
import { routeHref } from '../core/url.js';
import { page, breadcrumbs } from '../components/chrome.js';
import { ctaSection } from '../components/ctaSection.js';
import { processSection } from '../components/processSection.js';
import { icon } from '../components/icon.js';
import { services } from '../data/services.js';

const linkLabels = {
  '/games': 'services.link.games',
  '/contact': 'services.link.contact',
  '/lab': 'services.link.lab',
};

const pageHead = () => html`
  <section class="pagehead" aria-labelledby="services-title">
    <div class="shell">
      ${breadcrumbs('nav.services')}
      <div class="pagehead__grid">
        <div>
          <p class="kicker">${t('services.label')}</p>
          <h1 class="pagehead__title" id="services-title">${t('services.title')}</h1>
          <p class="pagehead__lede">${t('services.lede')}</p>
        </div>
        <aside class="pagehead__aside">
          <p class="pagehead__note">
            <strong>${String(services.length).padStart(2, '0')}</strong>${t('home.stats.disciplines')}
          </p>
          <p class="pagehead__meta">
            <span>Games</span><span>Apps</span><span>Web</span><span>${t('services.tag.ai')}</span>
          </p>
          <a class="link-arrow" href="${routeHref('/contact')}">
            ${t('cta.start')}${icon('arrowRight', { size: 15 })}
          </a>
        </aside>
      </div>
    </div>
  </section>
`;

const offerings = () => html`
  <section class="section" id="disziplinen" aria-labelledby="tracks-title">
    <div class="shell">
      <div class="section-label">
        <span class="section-label__num">01</span>
        <span>${t('services.tracks.label')}</span>
      </div>
      <div class="section-head">
        <h2 class="section-head__title" id="tracks-title">${t('services.tracks.title')}</h2>
        <p class="section-head__lede">${t('services.tracks.lede')}</p>
      </div>

      ${services.map(
        (service, index) => html`
          <article class="offering" data-reveal>
            <div class="offering__head">
              <span class="offering__num" aria-hidden="true">${String(index + 1).padStart(2, '0')}</span>
              <span class="offering__icon" aria-hidden="true">${icon(service.icon, { size: 21 })}</span>
              <h2 class="offering__title">${t(`services.${service.slug}.title`)}</h2>
              <p class="offering__desc">${t(`services.${service.slug}.description`)}</p>
            </div>
            <div class="offering__foot">
              <ul class="offering__features">
                ${Array.from({ length: service.features }, (_, feature) => html`
                  <li>
                    ${icon('check', { size: 14 })}
                    <span>${t(`services.${service.slug}.feature${feature + 1}`)}</span>
                  </li>
                `)}
              </ul>
              <a class="link-arrow" href="${routeHref(service.link)}">
                ${t(linkLabels[service.link])}${icon('arrowRight', { size: 16 })}
              </a>
            </div>
          </article>
        `,
      )}
    </div>
  </section>
`;

const principles = () => html`
  <section class="section principles" aria-labelledby="principles-title">
    <div class="shell">
      <div class="section-label">
        <span class="section-label__num">03</span>
        <span>${t('services.principles.label')}</span>
      </div>
      <div class="section-head">
        <h2 class="section-head__title" id="principles-title">${t('services.principles.title')}</h2>
        <p class="section-head__lede">${t('services.principles.lede')}</p>
      </div>
      <div class="principles__grid">
        ${[1, 2, 3].map(
          (index) => html`
            <article class="principle" data-reveal>
              <span class="principle__num" aria-hidden="true">${String(index).padStart(2, '0')}</span>
              <h3 class="principle__title">${t(`services.principle${index}.title`)}</h3>
              <p class="principle__text">${t(`services.principle${index}.text`)}</p>
            </article>
          `,
        )}
      </div>
    </div>
  </section>
`;

export const ServicesPage = () => page(html`
  ${pageHead()}${offerings()}${processSection({ number: '02' })}${principles()}
  ${ctaSection({
    labelKey: 'services.cta.label',
    titleKey: 'services.cta.title',
    ledeKey: 'services.cta.lede',
    buttonKey: 'services.cta.button',
  })}
`);
